import { IUser } from "@/models/user.entity";
import {
  MrfiktivFleetPermissionDtoGen,
  MrfiktivPermissionDtoGen,
  MrfiktivPartnerPermissionDtoGen
} from "@/services/mrfiktiv/v1/data-contracts";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { AuthRolesEnum } from "@/store/enum/authRolesEnum";
import { AbilityBuilder, Ability } from "@casl/ability";

type CanFn = (action: string | string[], subject: string, field?: string) => void;
type AnyPermission = MrfiktivPermissionDtoGen | MrfiktivFleetPermissionDtoGen | MrfiktivPartnerPermissionDtoGen;

export function applyPermission(p: AnyPermission, can: CanFn): void {
  if ("id" in p) {
    const perm = p as MrfiktivPermissionDtoGen;
    perm.action?.forEach((action: string | string[]) => can(action, perm.type, perm.id));
  } else if ("fleetId" in p) {
    const perm = p as MrfiktivFleetPermissionDtoGen;
    perm.action?.forEach((action: string | string[]) => can(action, perm.type, perm.fleetId));
  }
  // FIXME: Not sure what partnerPermissions are used for compared to regular permissions, so I wont activate this until clear
  // else if ("partnerId" in p) {
  //   const perm = p as MrfiktivPartnerPermissionDtoGen;
  //   perm.action?.forEach((action: string | string[]) => can(action, perm.type, perm.partnerId));
  // }
}

/**
 * @param user contains details about logged in user: its id, name, email, etc
 */
export function defineAbilitiesFor(user?: IUser) {
  const { can, rules } = new AbilityBuilder(Ability);
  if (!user) {
    return rules;
  }

  const roles = user.roles ?? [];
  const permission = user.permission ?? [];

  if (roles.includes(AuthRolesEnum.ADMIN)) {
    can(ActionEnum.MANAGE, ResourceEnum.ALL);
    return rules;
  }

  if (roles.includes(AuthRolesEnum.DOCPHANT_ADMIN)) {
    can(ActionEnum.MANAGE, ResourceEnum.MANUFACTURER);
    can(ActionEnum.MANAGE, ResourceEnum.MACHINE);
    can(ActionEnum.MANAGE, ResourceEnum.MACHINE_ATTACHMENT);
  }

  if (roles.includes(AuthRolesEnum.THG_USER)) {
    can(ActionEnum.READ, ResourceEnum.THG);
  }

  if (roles.includes(AuthRolesEnum.USER)) {
    can(ActionEnum.READ, ResourceEnum.LOGGED_IN_USER);
  }

  if (roles.includes(AuthRolesEnum.ANALYTICS_ADMIN)) {
    can(ActionEnum.READ, ResourceEnum.ANALYTICS_ADMIN);
    can(ActionEnum.READ, ResourceEnum.DASHBOARD);
  }

  // if (roles.includes(AuthRolesEnum.THG_PROCESSING)) {
  //   can(ActionEnum.MANAGE, ResourceEnum.THG_WORKITEMS);
  //   can(ActionEnum.MANAGE, ResourceEnum.THG);
  //   can(ActionEnum.READ, ResourceEnum.DASHBOARD);
  // }

  if (roles.includes(AuthRolesEnum.PARTNER)) {
    can(ActionEnum.READ, ResourceEnum.DASHBOARD);
  }

  permission.forEach((p) => applyPermission(p, can));
  return rules;
}
